<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.weChatOrderList.push"
    :is-show-search-input="true"
    search-placeholder="请输入学员姓名、手机号或订单号"
  >
    <v-column-time/>
    <v-column-time value="更新时间" field="update_time" sort=""/>
    <v-column-time value="支付完成时间" field="success_time_int" sort=""/>
    <el-table-column label="订单 ID" prop="id"/>
    <el-table-column label="商户订单号" prop="out_trade_no"/>
    <el-table-column label="微信支付订单号" prop="transaction_id"/>
    <v-column-student label="下单学员" link-page-id="student_id"/>
    <el-table-column label="订单总金额">
      <template v-slot="{ row }">
        {{ row.total | toYuan }}
      </template>
    </el-table-column>
    <el-table-column label="预支付会话标识" prop="prepay_id"/>

    <el-table-column label="交易类型" prop="trade_type"/>
    <el-table-column label="交易状态" prop="trade_state"/>
    <el-table-column label="交易状态描述" prop="trade_state_desc"/>
    <el-table-column label="付款银行" prop="bank_type"/>
    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`we-chat-order-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>更新时间</span>
              <span>{{ v.update_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>支付完成时间</span>
              <span>{{ v.success_time_int | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>订单 ID</span>
              <span>{{ v.id }}</span>
            </div>
            <div class="list-item-detail">
              <span>商户订单号</span>
              <span>{{ v.out_trade_no }}</span>
            </div>
            <div class="list-item-detail">
              <span>微信支付订单号</span>
              <span>{{ v.transaction_id }}</span>
            </div>
            <div class="list-item-detail">
              <span>下单学员</span>
              <v-avatar-nickname
                :value="v.selfie"
                :nickname="v.student_name"
                :link-page-name="RouteConfig.studentDetail.name"
                :link-page-id="v.student_id"
                :avatar-size="50"
                width="30vw"
              />
            </div>
            <div class="list-item-detail">
              <span>订单总金额</span>
              <span>{{ v.total | toYuan }}</span>
            </div>
            <div class="list-item-detail">
              <span>预支付会话标识</span>
              <span>{{ v.prepay_id }}</span>
            </div>
            <div class="list-item-detail">
              <span>交易类型</span>
              <span>{{ v.trade_type }}</span>
            </div>
            <div class="list-item-detail">
              <span>交易状态</span>
              <span>{{ v.trade_state }}</span>
            </div>
            <div class="list-item-detail">
              <span>交易状态描述</span>
              <span>{{ v.trade_state_desc }}</span>
            </div>
            <div class="list-item-detail">
              <span>付款银行</span>
              <span>{{ v.bank_type }}</span>
            </div>
          </div>
        </template>
        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { getLegalQueryList } from '@/utils/formats';
import { index } from '@/api/we-chat-order';

export default {
  name: RouteConfig.weChatOrderList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    isDeleting: true,
    count: 0,
    list: [],
    queryList: {
      keyword: '',
      is_asc: 0,
      page: 1,
      size: 8,
    },
  }),
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    async load(route = this.$route) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      this.isLoading = true;
      const { isError, data } = await index(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
    },
  },
};
</script>
